import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-construction',
  imports: [PillarPagesTemp],
  templateUrl: './construction.html',
  styleUrl: './construction.scss',
})
export class Construction {

}
